/**
 * hub.coranchers.com API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InventoryCountingModel { 
    inventoryCountingId?: number;
    inventoryCountingNumber?: string | null;
    locationId?: number;
    siteId?: number;
    dateTime?: string;
    inventoryCountingName?: string | null;
    userId?: number;
    createdDateTime?: string;
    modifiedDateTime?: string;
    assignedToUserId?: number;
    statusId?: number;
    locationIdentifier?: string | null;
    siteName?: string | null;
    assignedToUserDisplay?: string | null;
    statusDisplay?: string | null;
    totalCountRecords?: number;
    gpAdjustmentNumber?: string | null;
}

